<template>
  <div>
    <div v-if="pickupTimes && pickupTimes.length">
      <div v-if="shouldGroupOutbound">
        <v-chip
          v-for="group in pickupTimesGrouped"
          :key="group.key"
          class="ma-1"
          small
          :close="isAdmin && !disabled"
          @input="onDelete(group.firstIndex)"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <span>{{ group.displayNameTruncated }}</span>
                <span v-if="group.timesDisplayText"> — </span>
                <span v-if="group.timesDisplayText">{{ group.timesDisplayText }}</span>
              </span>
            </template>
            <span>
              {{ group.displayName }}
              <span v-if="group.timesDisplayText"> — {{ group.timesDisplayText }}</span>
            </span>
          </v-tooltip>
          <v-btn
            v-if="isAdmin"
            icon
            small
            class="ml-1"
            @click.stop="onEdit(group.firstIndex)"
            title="Edit pickup time"
          >
            <v-icon small>fas fa-pencil</v-icon>
          </v-btn>
        </v-chip>
      </div>
      <v-chip
        v-else
        v-for="(pickup, index) in pickupTimesParsed"
        :key="index"
        class="ma-1"
        small
        :close="isAdmin && !disabled"
        @input="onDelete(index)"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <span v-if="!busStopOnly">{{ pickup.displayTime }}</span>
              <span v-if="!busStopOnly && !timeOnly"> — </span>
              <span v-if="!timeOnly && (pickup.busStopId || pickup.label)">{{ pickup.displayName }}</span>
            </span>
          </template>
          <span>{{ getPickupDisplayName(pickup) }}</span>
        </v-tooltip>
        <v-btn
          v-if="isAdmin"
          icon
          small
          class="ml-1"
          @click.stop="onEdit(index)"
          title="Edit pickup time"
        >
          <v-icon small>fas fa-pencil</v-icon>
        </v-btn>
      </v-chip>
    </div>
    <div v-else class="caption grey--text mb-1">
      {{ busStopOnly ? 'No bus stops added yet.' : (timeOnly ? 'No event times added yet.' : 'No pickup times added yet.') }}
    </div>
    <v-btn
      small
      class="mt-1"
      :disabled="Boolean(!isAdmin || disabled)"
      @click="onAdd"
    >
      <v-icon left small>fal fa-plus</v-icon>
      {{ busStopOnly ? 'Add bus stop' : (timeOnly ? 'Add time' : 'Add time/stop') }}
    </v-btn>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
